import '../styles/BankingAccount.scss';
import UniTable, { DataTable } from '../components/UniTable/UniTable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmarkCircle, faSearch, faBank } from '@fortawesome/free-solid-svg-icons';
import Button from "react-bootstrap/esm/Button";
import { useNavigate } from "react-router-dom";
import UniInput, { FormControlElement } from "../components/UniInput/UniInput";
import UniPagination from "../components/UniPagination/UniPagination";
import { ChangeEvent, useEffect, useState } from 'react';
import UniModal from '../components/UniModal/UniModal';
import { useUserStore } from '../store/user';
import { BankAccount, getBankingAccounts } from '../services/bankingAccountService';
import { Country, getOnlyCountries } from '../services/usefulLinkService';
import { useTranslation } from 'react-i18next';


type SearchForm = {
    search?: string,
    enabled?: string,
    country?: string
};

const BankingAccount = () =>{
    const navigate = useNavigate();
    const [page, setPage] = useState<number>(1);
    const [take, setTake] = useState<any>(10);
    const [error, setError] = useState<string>(``);
    const [bankingAccounts, setbankingAccounts] = useState<BankAccount[]>([]);
    const { loginData, darkMode } = useUserStore();
    const [loading, setLoading] = useState<boolean>(false);
    const [search, setSearch] = useState<SearchForm>();
    const [totalPages, setTotalPages] = useState<number>();
    const [totalItems, setTotalItems] = useState<number>();
    const [countries, setCountries] = useState<Country[] | undefined>();
    const { i18n, t } = useTranslation();

    useEffect(() => {
        if (localStorage.getItem('tkn')) {
            getBankAccount();
            getGroupsLink();
        }
    }, [loginData.id, take, page, i18n.language]);

    const goToManage = (id?: string) => {
        if (id) {
            navigate(`manage-banking-account/${id}`);
            return;
        }

        navigate('manage-banking-account');
    }

const dataTable: DataTable[] = [
    {
        property: 'id',
        name: `id`,
        notShow: true,
    },
    {
        property: 'bank',
        name: t('banking.bank'),
        isName: true
    },
    {
        property: 'agency',
        name: t('banking.agency'),
        isName: true
    },
    {
        property: 'currentAccount',
        name: t('banking.account'),
        isName: true
    },
    {
        property: 'pixKey',
        name: t('banking.pixKey'),
        isName: true,
    },
    {
        property: 'companyName',
        name: t('banking.companyName'),
        isName: true
    },
    {
        property: 'companyDocument',
        name: t('banking.companyDocument'),
        isName: true
    },
    {
        property: 'country',
        name: t('banking.country'),
        isEnum: true,
        //enumFunc: getEnumCountry
    },
    {
        property: 'enabled',
        name: 'Status',
        isStatus: true
    },
    {
        property: 'actions',
        name: t('banking.labelActions'),
        isAction: true,
    }

];

const onChangeSearch = (e: ChangeEvent<FormControlElement> | ChangeEvent<HTMLSelectElement>, typeValue = `search`) => {
    console.log(e?.target?.value, typeValue)
    switch (typeValue) {
        case `search`:
            setSearch({ ...search, search: e?.target?.value });
            break;
        case `country`:
            setSearch({ ...search, country: e?.target?.value });
            break;
        case `enabled`:
            setSearch({ ...search, enabled: e?.target?.value });
            break;
        default:
            setSearch({ ...search, search: e?.target?.value });
    }
}

const getGroupsLink = () =>{
    setLoading(true)
    getOnlyCountries()
    .then(response => {
        if (!response.success) {
            setError(response.error);
            console.log(error)
        }
        else {
            setCountries(response.countries);
        }
    })
    .catch(e => console.log(e))
    .finally(() => setLoading(false));

};

const getCountryDescription = (country : Country) => {
    switch (i18n.language) {
      case 'es':
        return country.descriptionES;
      case 'en':
        return country.descriptionEN;
      default:
        return country.descriptionBR;
    }
  };

const getBankAccount = () => {
    setLoading(true);
    setError('');

    getBankingAccounts(i18n.language,
                    take,
                    page,
                    search?.search ?? '',
                    search?.country ?? '',
                    search?.enabled ?? undefined
    )
    .then (response => {
        if(!response.success) {
            setError(response.error ?? '');
            setbankingAccounts([]);
        }
        else{
            setbankingAccounts(response.data);
            setTotalItems(response.totalItems);
            setTotalPages(response.totalPages);
        }
    })
    .finally(() => setLoading(false))
}


return (
<>
    <div className='banking-account-wrapper' >
        <div className='banking-account-header w-100'>
            <div className='banking-account-header-i'>
                <FontAwesomeIcon icon={faBank} color='#00FF3C' size='xl'/>
                <p className='w-100'>{t('bankingAccount')}</p>
            </div>
            <Button variant='primary' onClick={() => goToManage()} disabled={loading}>
                <FontAwesomeIcon style={{paddingRight: '5px'}} icon={faBank} color='#00FF3C' size='xl' />
                {t('banking.new')}
            </Button>
        </div>
        <div className='banking-account-search w-100'>
            <div>
                <UniInput
                    id='search'
                    placeholder={t('banking.searchBy')}
                    label={t('banking.search')}
                    type='text'
                    onChangeInput={(e) => onChangeSearch(e)}
                    disabled={loading}
                />
            </div>
            <div>
                <UniInput
                    id='country'
                    placeholder={t('notification.labelContry')}
                    label={t('notification.labelContry')}
                    isSelect
                    disabled={loading}
                    onChange={(e) => onChangeSearch(e, 'country')}
                >
                    <option value={''}>{t('link.selectAll')}</option>
                             {countries?.map(country => (
                                <option key={country.id} value={country.id}>
                                 { getCountryDescription(country)}
                                </option>
                            ))}
                </UniInput>
            </div>
            <div>
                <UniInput
                    id='enabled'
                    placeholder='enabled'
                    label='Status'
                    isSelect
                    disabled={loading}
                    onChange={(e) => onChangeSearch(e, 'enabled')}
                    >
                    <option value={''}>{t('link.selectAll')}</option>
                    <option value={'true'}>{t('banking.active')}</option>
                    <option value={'false'}>{t('banking.inactive')}</option>
                </UniInput>
            </div>

            <FontAwesomeIcon icon={faSearch} title={t('customerScreen.search')} onClick={() => getBankAccount()}/>
        </div>
        <div className='w-100 d-flex justify-content-center'>
                    <UniTable
                        data={bankingAccounts}
                        dataTable={dataTable}
                        darkMode={darkMode}
                        loading={loading}
                        error={''}
                        actionsEdit
                        actionEdit={(id: string) => {goToManage(id)}}
                    />
                </div>
                {
                    <UniPagination totalItems={totalItems} totalPages={totalPages} changePage={(e) => setPage(e)} changeTake={(e) => { setPage(1); setTake(e) }} />
                }

    </div>

    <UniModal
                icon={faXmarkCircle}
                message=''
                iconColor='#EA2027'
                title={error}
                onHide={() => {setError('')}}
                show={error !== ''}
                isFontAwsome
            />
</>

);

}

export default BankingAccount;
